module.exports = __webpack_public_path__ + "img/about-banner.9226d107.png";